export default __webpack_public_path__ + "static/media/strategyChi1.056e0ed7.jpg";